import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useApp } from "../context/AppContext";
import { PRIVACY_AR, PRIVACY_EN } from "../legal/privacyTexts";
import { getPublicAssetUrl } from "../config/logoSizes";

const SITE_NAME = "TaweelAI";
const CONTACT_EMAIL = "TaweelAi.Support@gmail.com";

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const { language } = useApp();
  const isAr = language === "ar";
  const content = isAr ? PRIVACY_AR : PRIVACY_EN;

  return (
    <div
      dir={isAr ? "rtl" : "ltr"}
      style={{
        position: "fixed",
        inset: 0,
        overflowY: "auto",
        background: "var(--bg-base)",
        color: "var(--text-1)",
        padding: "32px 18px 48px",
        fontFamily: "'Inter','Outfit','Nunito',sans-serif"
      }}
    >
      <div
        style={{
          maxWidth: 820,
          margin: "0 auto",
          background: "var(--bg-card)",
          border: "1px solid var(--border)",
          borderRadius: 18,
          padding: "28px 28px 36px",
          boxShadow: "var(--shadow-s)"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: 20,
            marginBottom: 18,
            paddingBottom: 18,
            borderBottom: "1px solid var(--border)"
          }}
        >
          <div style={{ width: 260, height: 160, overflow: "hidden", flexShrink: 0 }}>
            <img
              src={getPublicAssetUrl("logo-light.svg")}
              alt={SITE_NAME}
              draggable={false}
              style={{ width: "100%", height: "auto", display: "block", objectFit: "cover", objectPosition: "top center" }}
            />
          </div>
          <div style={{ fontFamily: "'Outfit',sans-serif", fontSize: 22, fontWeight: 800, letterSpacing: "-0.4px", color: "var(--text-1)", marginTop: 2 }}>
            {SITE_NAME}
          </div>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            style={{
              color: "var(--accent)",
              textDecoration: "none",
              fontSize: 13,
              fontWeight: 600
            }}
          >
            {CONTACT_EMAIL}
          </a>
          <h1
            style={{
              fontFamily: "'Outfit',sans-serif",
              fontSize: 22,
              fontWeight: 800,
              margin: "4px 0 0",
              color: "var(--text-1)"
            }}
          >
            {t("privacyPolicy")}
          </h1>
        </div>

        <pre
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            fontFamily: "inherit",
            fontSize: 14.5,
            lineHeight: 1.75,
            color: "var(--text-2)",
            margin: 0
          }}
        >
          {content}
        </pre>

        <div
          style={{
            marginTop: 24,
            paddingTop: 18,
            borderTop: "1px solid var(--border)",
            display: "flex",
            justifyContent: "center"
          }}
        >
          <Link
            to="/chat"
            style={{
              padding: "10px 18px",
              background: "var(--accent)",
              color: "#fff",
              borderRadius: 10,
              textDecoration: "none",
              fontWeight: 700,
              fontSize: 14,
              fontFamily: "'Outfit',sans-serif"
            }}
          >
            {isAr ? "العودة" : "Back"}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
